import { Info } from "lucide-react"

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"

export default function RecordFieldTooltip({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <Tooltip>
      <TooltipTrigger>
        <Info className="text-muted-foreground size-4" />
      </TooltipTrigger>
      <TooltipContent>{children}</TooltipContent>
    </Tooltip>
  )
}
